import React from 'react';
import { title } from '../config/config';
import { Link } from 'react-router-dom';

const Footer = () => {
     return (
          <footer className='footer'>
               <div className='footer-in'>
                    <p>© Copyright © 2026  {title} | Powered by  <Link to={'https://www.instagram.com/thedc__'} target='_blank' > {'thedc'}</Link> </p>

                         <ul>
                              <li>
                                   <Link target='_blank' to="https://stats.uptimerobot.com/5VBCGhmkj8">
                                        <img src="https://stats.uptimerobot.com/assets/favicon.ico" width="20px" height="20px" className='me-2' style={{ marginTop: "-5px" }} alt='icon' />
                                        Status</Link>
                              </li>

                              <li>
                                   <Link to="/"> Home</Link>
                              </li>
                              <li>
                                   <Link to="/about"> About</Link>
                              </li>

                              <li>
                                   <Link to="/privacy-policy"> Privacy & Policy</Link>
                              </li>
                              <li>
                                   <Link to="/blogs"> Blogs</Link>
                              </li>
                         </ul>
               </div>

               <h2 className='__dk3'> {title}</h2>

          </footer>
     );
}

export default Footer;
